import React, { useEffect, useState } from "react";
import Divider from "../ui/Divider";
import Space from "../ui/Space";
import Nav from "../ui/Nav";
import { KBD } from "../utils/Keybindings";
import { getSignal } from "../App";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import VirtualTable from "../ui/VirtualTable";
import { nextRow, prevRow } from "../utils/Utils";
import Alert from "../ui/Alert";
import TestComponent from "../components/TestComponent";

export default function TestController(props) {

    const { route = ROUTES.MISC.TEST, setController = () => { } } = props;

    // States
    const [selected, setSelected] = useState({});
    const [view, setView] = useState("list");


    // Navigation
    const nav = [
        { text: "Escape", key: KBD.ESCAPE, action: () => setController("home") },
        { text: "Inventory", key: KBD.Digit2, action: () => setController("inventory") },
    ]

    // Keyboard Listener
    useEffect(() => {
        setSelected(data[0]);
        const cleanup = listen(route, nav);
        return cleanup;
    }, [])


    useEffect(() => {

        window.bm_state.value = (view === "details") ? ROUTES.MISC.TEST_DETAILS : route;

    }, [view])




    // Table
    const columns = [
        { key: "a", title: <>A</>, width: 100 },
        { key: "b", title: <>B</>, width: 900, grow: true },
        { key: "c", title: <>C</>, width: 100, render: (e, f) => { return (<a>{e}</a>) } }
    ]

    const data = Array.from({ length: 30 }, (_, index) => ({
        id: index + 1,
        a: `a ${index + 1}`,
        b: `b ${index + 1}`,
        c: `c ${index + 1}`,
        d: `d ${index + 1}`
    }));

    const drawTable = () => {
        return (
            <VirtualTable
                row_key={"id"}
                route={route}
                columns={columns}
                data={data}
                current={selected}
                align={"auto"}
                onRowClick={(item, event, index) => { setSelected(item) }}
                next={() => nextRow("id", data, selected, setSelected, 1, 20)}
                prev={() => prevRow("id", data, selected, setSelected, 1, 20)}
                // small
                // medium
                // header={<small>Header</small>}
                // className="desaturate"
                // scrollbar={true}
                // scrollindicator={true}
                // infinite={true}
                // onLoadMore={(_start, _end, _prepend) => {
                //     if (_prepend) {
                //         if (data?.length > 0) {
                //             console.log("prev")
                //         }
                //     } else {
                //         if (data?.length > 0) {
                //             console.log("next")
                //         }

                //     }
                // }}
                // width={398}
                // offset={449}
                // height={202}
                fullHeight
                scrollBar={true}

            />
        )


    }


    const drawModal = () => {


    }


    // Layout
    return (
        <div className="controller controller-layout">
            <div onClick={() => setView("details")} className="header-card">

                <TestComponent view={view} setView={setView} selected={selected} />
            </div>

            <div className="list-card flex-height">
                <pre>{JSON.stringify(selected, null, 2)}</pre>
            </div>

            <div className="list-card flex-height">
                {drawTable()}
            </div>


            <div className="flex-bottom">
                <div className="shim" />
                <Divider />
                <div className="nav-wrapper">
                    <Space style={{ padding: "0px 15px" }}>
                        <Nav nav={nav} />
                    </Space>
                </div>
            </div>
        </div>
    )
}